// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ed5fe2 {
  display: block;
  margin: 0 0 4px;
}
.fc2e80::after {
  content: " *";
  color: var(--base-validation-error);
}
.efbd03.efbd03 {
  margin: 0;
}
.cb73d4 {
  text-align: center;
}
.ec1bcc {
  text-align: left;
}
.ca0a66 {
  text-align: right;
}
.b69ca9 {
  width: 100%;
}
.c67399 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.f05b31 {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.a545be {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.b35ec7 {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.ad5460 {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

@supports (-webkit-line-clamp: 2) {
  .f05b31 {
    white-space: initial;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
  }
}

@supports (-webkit-line-clamp: 3) {
  .a545be {
    white-space: initial;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
  }
}

@supports (-webkit-line-clamp: 4) {
  .b35ec7 {
    white-space: initial;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
  }
}

@supports (-webkit-line-clamp: 5) {
  .ad5460 {
    white-space: initial;
      display: -webkit-box;
      -webkit-line-clamp: 5;
      -webkit-box-orient: vertical;
  }
}`, "",{"version":3,"sources":["webpack://./node_modules/@hm-group/fabric-components/dist/esm/brand/hm/components/Typography/texts/FormLabel/FormLabel.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,mCAAmC;AACrC;AACA;EACE,SAAS;AACX;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE;IACE,oBAAoB;MAClB,oBAAoB;MACpB,qBAAqB;MACrB,4BAA4B;EAChC;AACF;;AAEA;EACE;IACE,oBAAoB;MAClB,oBAAoB;MACpB,qBAAqB;MACrB,4BAA4B;EAChC;AACF;;AAEA;EACE;IACE,oBAAoB;MAClB,oBAAoB;MACpB,qBAAqB;MACrB,4BAA4B;EAChC;AACF;;AAEA;EACE;IACE,oBAAoB;MAClB,oBAAoB;MACpB,qBAAqB;MACrB,4BAA4B;EAChC;AACF","sourcesContent":[".ed5fe2 {\n  display: block;\n  margin: 0 0 4px;\n}\n.fc2e80::after {\n  content: \" *\";\n  color: var(--base-validation-error);\n}\n.efbd03.efbd03 {\n  margin: 0;\n}\n.cb73d4 {\n  text-align: center;\n}\n.ec1bcc {\n  text-align: left;\n}\n.ca0a66 {\n  text-align: right;\n}\n.b69ca9 {\n  width: 100%;\n}\n.c67399 {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.f05b31 {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.a545be {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.b35ec7 {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.ad5460 {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n@supports (-webkit-line-clamp: 2) {\n  .f05b31 {\n    white-space: initial;\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n  }\n}\n\n@supports (-webkit-line-clamp: 3) {\n  .a545be {\n    white-space: initial;\n      display: -webkit-box;\n      -webkit-line-clamp: 3;\n      -webkit-box-orient: vertical;\n  }\n}\n\n@supports (-webkit-line-clamp: 4) {\n  .b35ec7 {\n    white-space: initial;\n      display: -webkit-box;\n      -webkit-line-clamp: 4;\n      -webkit-box-orient: vertical;\n  }\n}\n\n@supports (-webkit-line-clamp: 5) {\n  .ad5460 {\n    white-space: initial;\n      display: -webkit-box;\n      -webkit-line-clamp: 5;\n      -webkit-box-orient: vertical;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
